import { ConnectionsEmptyOrError } from '@terminal/modules/overview-knowledge-graph/components/shared/section-base/SectionBase';
import { useCompanyCountryExposure } from '@terminal/react-query-hooks/knowledge-graph/useKnowledgeGraph';
import { httpCode } from '@terminal/utils/api-fetch/httpCode';
import { useTranslation } from 'react-i18next';
import { RankingMethodologySection } from '../../theme-exposure-tab/theme-exposure-table/ranking-methodology-section/RankingMethodologySection';
import { GeographicExposureTable } from '../components/GeographicExposureTable';
import { useGeographicDrawer } from '../drawers/useGeographicDrawer';
import styles from './GeographicExposureSubTab.module.scss';

export interface CountryExposureTabProps {
  entityTag: string;
}

export const CountryExposureTab = ({ entityTag }: CountryExposureTabProps) => {
  const { t } = useTranslation(['widget']);
  const { openCountry } = useGeographicDrawer({ entityTag });

  const {
    data = [],
    error,
    isFetching,
  } = useCompanyCountryExposure({
    entityTag,
    enabled: !!entityTag,
  });

  if (error && error.status !== httpCode.notFound) {
    return (
      <div className={styles.subTabRoot}>
        <div className={styles.tabContent}>
          <ConnectionsEmptyOrError variant="error" errorSize="fullView" />
        </div>
        <RankingMethodologySection rankingType="companyToGeographicExposure" />
      </div>
    );
  }

  if (!isFetching && data.length === 0) {
    return (
      <div className={styles.subTabRoot}>
        <div className={styles.tabContent}>
          <ConnectionsEmptyOrError
            variant="empty"
            layout="fillContainer"
            imageSize="full"
            title={t(
              'widget:assetOverview.knowledgeGraphRevamp.empty.geographicExposure'
            )}
          />
        </div>
        <RankingMethodologySection rankingType="companyToGeographicExposure" />
      </div>
    );
  }

  return (
    <GeographicExposureTable
      mode="country"
      data={data}
      isFetching={isFetching}
      onRowClick={openCountry}
    />
  );
};
